import { Component, OnInit } from '@angular/core';
import { FinishingService } from '../../services/finishing.service';

@Component({
  selector: 'app-finishing',
  templateUrl: './finishing.component.html',
  styleUrls: ['./finishing.component.css']
})
export class FinishingComponent implements OnInit {
  finishingOfice: finishingOficeResponse;

  constructor(public finishing: FinishingService) {
    this.finishing.get().subscribe((res)=>{
       this.finishingOfice = res['data'];
       console.log(this.finishingOfice);
    })
   }

  ngOnInit() {
  }

}
interface finishingOficeResponse{
  finishingOfices:any[];
  
}


// WEBPACK FOOTER //
// ./src/app/pages/finishing/finishing.component.ts